import { getAxiosInstance } from "../ApiConfig";

async function getViewALL(viewType) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/findAllByViewType/${viewType}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getViewType(viewType, id) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/selectedView/${viewType}/${id}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getViewTypeBySearch(viewType, id, search) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/selectedView/${viewType}/${id}?search=${search}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getViewPagination(viewType, id, page, limit) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/selectedView/${viewType}/${id}?page=${page}&limit=${limit}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getViewPaginationSearch(viewType, id, page, limit, search) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/selectedView/${viewType}/${id}?page=${page}&limit=${limit}&search=${search}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function selectedViewByCompany(viewType, id, page, limit, search) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/selectedViewByCompany/${viewType}/${id}?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getByViewId(id) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getByViewId/${id}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getQueryFieldsByType(type, page) {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getQueryFields/${type}/${page}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteViewId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteView/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ViewSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createView`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
const getAllRelatedEntity = async (Entity, type) => {
    try {
        const data = await getAxiosInstance().get(`/Template/getAllRelatedEntity/${Entity}/${type}`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ViewUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateView/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function queryFetchDataPagination(payload, entity, page, limit) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQuery/${entity}?page=${page}&limit=${limit}`, payload);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function queryFetchDataSearch(payload, entity, search) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQuery/${entity}?search=${search}`, payload);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function queryFetchDataPaginationSearch(payload, entity, page, limit, search) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQuery/${entity}?page=${page}&limit=${limit}&search=${search}`, payload);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function selectedViewQueryLeadStatusAndCompany(payload, entity, page, limit, leadStatusId) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQueryLeadStatusAndCompany/${entity}?${leadStatusId ? `leadStatusId=${leadStatusId}&page=${page}&limit=${limit}` : `page=${page}&limit=${limit}`}`, payload);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function selectedViewQueryCompany(payload, entity) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQueryLeadStatusAndCompany/${entity}`, payload);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function queryFetchData(payload, entity) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQuery/${entity}`, payload);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    selectedViewByCompany,
    getViewType,
    getViewALL,
    ViewSave,
    ViewUpdate,
    getByViewId,
    deleteViewId,
    getViewTypeBySearch,
    getQueryFieldsByType,
    getViewPagination,
    getViewPaginationSearch,
    queryFetchData,
    queryFetchDataSearch,
    queryFetchDataPagination,
    queryFetchDataPaginationSearch,
    selectedViewQueryLeadStatusAndCompany,
    selectedViewQueryCompany,
    getAllRelatedEntity,
}